export default __webpack_public_path__ + "images/467f20566f77ca915f01d3b55c667163.svg";